export enum AudienceStatus {
	Incomplete = 1,
	Ready = 2,
	Locked = 3,
	Publishing = 4,
	Queued = 5,
	Live = 6,
	Closed = 7,
	Archived = 8,
	Error = 9,
	Cancelled = 10,
}
